










































































































































































































































import { startCase } from 'lodash';
import { PropType } from 'vue';
import moment from 'moment';
import {
  EmployeeHourlySubType,
  IEmployee,
  IOvertimeRequest,
  IOvertimeRequestAttachment,
  IUserData,
  OvertimeRequestStateEnum
} from '@/models';

import ErrorAlert from '../common/ErrorAlert.vue';
import OvertimeRequestDetailMenuCardStateActionButtons from './OvertimeRequestDetailMenuCardStateActionButtons.vue';
import OvertimeApproverList from './OvertimeApproverList.vue';
import OvertimeRequestCommentList from './OvertimeRequestCommentList.vue';
import { mapActions } from 'vuex';
import { ErrorManager } from '@/models/error';

import mixins from '@/utils/mixins';
import SnackbarMixin from '@/mixins/snackbar';
import authMixin from '@/mixins/auth';

import { createFile } from '@/utils/helpers';
import ALDialog from '../core/Dialog/ALDialog.vue';

export default mixins(SnackbarMixin, authMixin).extend({
  components: {
    OvertimeRequestDetailMenuCardStateActionButtons,
    ErrorAlert,
    OvertimeApproverList,
    OvertimeRequestCommentList,
    ALDialog
  },
  props: {
    dialog: Boolean,

    request: {
      type: Object as PropType<IOvertimeRequest>
    },

    canRejectOrApproveState: Boolean,
    canCancel: Boolean
  },
  data() {
    return {
      OvertimeRequestStateEnum,
      EmployeeHourlySubType,
      errorMessage: '',
      errorMessageDetail: ''
    };
  },

  computed: {
    overtimeStateColor(): string {
      return this.request.getStateInfo().color;
    },
    overtimeStateDisplayName(): string {
      return this.request.getStateInfo().display_name;
    }
  },

  methods: {
    ...mapActions({
      downloadOvertimeAttachment: 'overtimeRequest/downloadOvertimeAttachment'
    }),

    moment,

    startCase,

    showEndDate(request: IOvertimeRequest): boolean {
      return !moment(request.start).isSame(moment(request.end), 'date');
    },

    openCommentDialog(state: OvertimeRequestStateEnum) {
      this.$emit('openCommentDialog', state);
    },

    close() {
      this.$forceUpdate();
      this.$emit('close');
    },

    downloadAttachment(attachment: IOvertimeRequestAttachment) {
      this.clearAllErrors();

      this.downloadOvertimeAttachment({
        id: this.request.id,
        attachmentId: attachment.id
      })
        .then(data => {
          createFile(data, attachment.filename!);
        })
        .then(() => {
          this.createSnack({
            color: 'success darken-1',
            type: 'download',
            right: true,
            useBtn: false,
            msg: `Downloaded file: '${attachment.filename}'`,
            btnText: 'Close'
          });
        })
        .catch(error => {
          this.errorMessage = ErrorManager.extractApiError(error);
        });
    },

    rebuild() {
      this.$emit('rebuild');
      this.close();
    },

    clearAllErrors() {
      this.errorMessage = '';
      this.errorMessageDetail = '';
    },

    setErrorMessage(commentError: string, commentErrorDetail: string) {
      this.errorMessage = commentError;
      this.errorMessageDetail = commentErrorDetail;
    }
  }
});
